import service from '@/api/patientTherapies';
import {loading, alert, handleError} from '@/state/generators/helpers';

export const state = {
    service: service,
    active: []
};

export const getters = {
    active: function (state) {
        return state.active;
    }
};

export const mutations = {
    'SET_ACTIVE': function (state, therapies = []) {
        state.active = therapies;
    }
};

export const actions = {
    active: function ({commit, state}) {
        loading(commit);

        return state.service.fetchActive().then(response => {
            commit('SET_ACTIVE', response.data);
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    storeUser: function ({commit, state}, payload) {
        loading(commit);

        return state.service.storeUser(payload).then(response => {
            commit('ADD_ITEM', response.data);
            commit('SET_ITEM', response.data);
            commit('SET_ERRORS', {});
            alert(commit, this.$t('request.creation_is_successful'));
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    instantiate: function ({commit, state}, {templateId, data}) {
        loading(commit);

        return state.service.instantiateTemplate(templateId, data).then(response => {
            commit('ADD_ITEM', response.data);
            commit('SET_ITEM', response.data);
            commit('SET_ERRORS', {});
            alert(commit, this.$t('request.creation_is_successful'));
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    abort: function ({commit, state}, id) {
        loading(commit);

        return state.service.abort(id).then(response => {
            commit('REPLACE_ITEM', response.data);
            commit('SET_ITEM', response.data);
            alert(commit, this.$t('request.save_is_successful'));
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    }
};
